import { connect } from 'react-redux';
import { actions, selectors } from '../../../CollectionPanel/redux';
import { getIsDeviationInitialized, getUserCollectionsCount, getUserCollectionsHasMore, } from '../../../CollectionPanel/redux/selectors';
import { removeQueues } from '../../../Notifications/redux/actionCreators';
var mapStateToProps = function (state, _a) {
    var deviationId = _a.collectibleDeviation.deviationId;
    return ({
        isInitialized: getIsDeviationInitialized(state, deviationId),
        collectionsCount: getUserCollectionsCount(state, deviationId),
        hasMoreCollections: getUserCollectionsHasMore(state, deviationId),
        selectedFolderIds: selectors.getSelectedFolderIds(state, deviationId),
    });
};
var mapDispatchToProps = {
    initializeCollectionsForDeviation: actions.initializeDeviation,
    commitCollections: actions.commitCollectionsCustom,
    removeQueues: removeQueues,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=AddToCollectionPopup.container.js.map